import React, { FunctionComponent } from "react";
import commonStyles from "../../CommonStyles/CommonGraphStyles.module.css";
import IntBarChartOrg from "../IntBarChartOrg/IntBarChartOrg";
import IntBarTable from "../IntBarTable/IntBarTable";
import { Pie } from "react-chartjs-2";

type props = {
  analyticsData: any;
  usersList: any;
  checked: boolean;
  teamsData: any;
  history: any;
  filter: "MTD" | "YTD" | "PM" | "All" | "CUSTOM";
  source: boolean;
  taskFilter: any;
  leadFilter: any;
};

const InterestedPropertyType: FunctionComponent<props> = ({
  analyticsData,
  usersList,
  checked,
  history,
  teamsData,
  filter,
  source,
  taskFilter,
  leadFilter,
}) => {
  return (
    <>
      <div id="propertyType" className={commonStyles.graphContainer}>
        <IntBarChartOrg
          analyticsData={analyticsData}
          heading={"Interested Property Type"}
          type={"propertyType"}
          color={["#ED563B", "#173F5F"]}
          GraphType={Pie}
          style={{ width: "40%" }}
          history={history}
          filter={filter}
        />
        <div className={commonStyles.line}></div>
        <IntBarTable
          type={"propertyType"}
          data={analyticsData}
          heading={"Interested Property Type Summary"}
          usersList={usersList}
          checked={checked}
          teamsData={teamsData}
          style={{ width: "60%" }}
          filter={filter}
          history={history}
          source={source}
          taskFilter={taskFilter}
          leadFilter={leadFilter}
        />
      </div>
    </>
  );
};

export default InterestedPropertyType;
